import styled from '@emotion/styled'
import { CancelIcon, InfoIcon, color, spacer } from 'stylist'

export const CircleCancel = styled(CancelIcon)`
  background-color: ${color('cadet')};
  color: ${color('white')};
  margin-right: ${spacer(2)};
  border-radius: 6px;
  padding: 2px;
  stroke-width: 5px;

  &:hover {
    background-color: ${color('red')};
  }
`
CircleCancel.defaultProps = {
  size: 'xxs'
}

export const BlueInfo = styled(InfoIcon)`
  color: ${color('blue')};
`
BlueInfo.defaultProps = {
  size: 'xxs'
}



// WEBPACK FOOTER //
// ./src/components/Icon.js